import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { GroupedOrderModalLauncherBlockConfig } from '@front-platform/content-builder';
import { groupedOrderModalLauncherBlockResolveConfig } from '@front-platform/content-builder';
import { combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, input } from '@angular/core';

import { UrlParamsKeys } from '@config/keys/url-params.keys';

import { CartStoreSelector } from '@common/selectors/cart.selector';
import { ShopStoreSelector } from '@common/selectors/shop.selector';
import { BasketStoreSelector } from '@common/selectors/basket.selector';

import { DestroyerBase } from '@core/base/destroyer/destroyer.base';
import { ModalsService } from '@core/services/modals/modals.service';
import { GroupedOrderModalsAttributes } from '@config/modals/grouped-order-modals.config';
import { ShareGroupedOrderModalComponent } from '@shared/modals/share-grouped-order-modal/share-grouped-order-modal.component';
export interface GroupedOrderModalLauncherBlockRuntimeConfig {}

export type GroupedOrderModalLauncherBlockConfigInput = Partial<
  Omit<GroupedOrderModalLauncherBlockConfig, keyof GroupedOrderModalLauncherBlockRuntimeConfig> &
    GroupedOrderModalLauncherBlockRuntimeConfig
>;
export type GroupedOrderModalLauncherBlockResolvedConfig = Omit<
  GroupedOrderModalLauncherBlockConfig,
  keyof GroupedOrderModalLauncherBlockRuntimeConfig
> &
  Partial<GroupedOrderModalLauncherBlockRuntimeConfig>;
export interface GroupedOrderModalLauncherBlockContract extends ConfigComponentContract<
  GroupedOrderModalLauncherBlockConfigInput,
  GroupedOrderModalLauncherBlockResolvedConfig
> {}

@Component({
  template: ``,
  selector: 'app-grouped-order-modal-launcher-block',
  standalone: false,
})
export class GroupedOrderModalLauncherBlockComponent
  extends DestroyerBase
  implements OnInit, GroupedOrderModalLauncherBlockContract
{
  readonly config = input<GroupedOrderModalLauncherBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    GroupedOrderModalLauncherBlockConfig,
    GroupedOrderModalLauncherBlockRuntimeConfig
  >(groupedOrderModalLauncherBlockResolveConfig, () => ({ config: this.config() }));
  static handle = 'GroupedOrderModalLauncherBlock';

  constructor(
    private cartSelector: CartStoreSelector,
    private shopSelector: ShopStoreSelector,
    private basketSelector: BasketStoreSelector,
    private readonly modalsService: ModalsService,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    combineLatest([
      this.activatedRoute.queryParams,
      this.shopSelector.selectActive$,
      this.cartSelector.selectActive$,
      this.basketSelector.select,
    ])
      .pipe(takeUntil(this._destroyerRef))
      .subscribe(([queryParams, shop, cart, basket]) => {
        const isGroupedOrderAllowed = shop?.distribution_modes.find(
          distributionMode => distributionMode.type === cart?.type,
        )?.allow_grouped_order;
        if (
          (!queryParams.hasOwnProperty(UrlParamsKeys.JoinCartId) ||
            !queryParams.hasOwnProperty(UrlParamsKeys.ShareCode)) &&
          cart?.handle &&
          isGroupedOrderAllowed &&
          shop?.id &&
          !basket?.id &&
          !basket?.rejected
        ) {
          this.modalsService.open(
            ShareGroupedOrderModalComponent.handle,
            GroupedOrderModalsAttributes.ChooseOrderType,
          );
        }
      });
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(GroupedOrderModalLauncherBlockComponent, {
  'keyAliases': {},
});
